export const LogLevelValues = ["error", "warn", "info", "debug"] as const;
export type LogLevel = (typeof LogLevelValues)[number];

/**
 * A lookup with index for O(1) lookups of indexes
 */
export const LogLevelLookup = LogLevelValues.reduce((acc, curr, i) => {
  acc.set(curr, i);
  return acc;
}, new Map<LogLevel, number>());
